<template>
  <div class="titlebar">
    <div class="titlebar-hair"></div>
    <div class="titlebar-body">
      <div
        v-show="displayLeft"
        class="titlebar-body-left"
        @click="iconInvoke('left')"
      ></div>
      <div class="titlebar-body-middle">
        {{ content }}
      </div>
      <div
        :style="{ visibility: showRight }"
        class="titlebar-body-right"
        @click="iconInvoke('right')"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TitleBar',
  props: {
    content: {
      type: String,
      default: '付款码',
    },
    displayRight: {
      type: Boolean,
      default: true,
    },
    displayLeft: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showRight() {
      return this.displayRight ? 'visible' : 'hidden'
    },
  },
  methods: {
    iconInvoke(position) {
      this.$emit(`${position}Invoke`)
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.titlebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  background: #ffc300;
  width: 100%;
  .flex-column-center();
  &-hair {
    width: 100%;
    height: 20px;
    height: constant(safe-area-inset-top);
    height: env(safe-area-inset-top);
  }
  &-body {
    .flex-center(space-between);
    width: 100%;
    height: 44px;
    padding: 0 15px 0 18px;
    &-left {
      .size(22px);
      .bg-img(
        url(data:image/png;base64,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)
      );
    }
    &-middle {
      font-size: 18px;
      line-height: 44px;
      font-family: PingFangSC-Semibold;
      color: #222222;
      letter-spacing: 0;
      text-align: center;
    }
    &-right {
      .size(26px);
      .bg-img(
        url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAAldJREFUeAHtlr2KGlEYhleDFlusXaqQwngBC5JtlzS5gFyAjYQ0YYu9AiGp06ewCrmELbJpUmwTgxCsREzlgiAEf4pVCGjej90JOpM58wmzhMAjHMfz/b3vPB50Dg54QQACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhA4L8lUPA6r9frh/P5/Ol6vT5Wz6RYLHaGw+EPb3+orlarPdHcE9U81NzvlUrlW7fbvQn1eHJ5eHYB0g0832w2ba1HMWNt3dC5QC1icddWc48E5p2Km9sNhULhWqupuZfb8X0+5+W5mCVqQrqJT3+BY61N5S5arVbmnLiO9VivzYjnTMs0TTue8+zz9PwgJGhHdLVafVbNUaDuca/X+zmdTjuBmkRqNBq9VvBVIrEbeFatVt+Px+Nfu+H0Xd6eg9+8/eaknJy4wxfxgGOf2WPa5sEx609J3p6DgHTM7Qc586UbcdVtD/L2eD1Es731Xv0gIIlOIuGMq7due4y3x1sXzfbWu+qCgOyvPFINXfWP8zWUT8m5Zns9RBreeq/nIKC755x2JJ5yXZZKpbcpudRwuVx+o+QyteA20d73WStvz0FA5tGec3S5uvWbeF8q/7Lf7w8SmYyA9VivytIgXd1pZ0xKpvP0nAlI38ii0Wic6kieaX2RnZnWQJ8/6BQcK/8xadEXsV6bYbNsptbMNLTOTNO0fZN2q+7T864SOwhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIACBf0vgN1QoAA9sZqBvAAAAAElFTkSuQmCC)
      );
    }
  }
}
</style>
